import {css} from "@panda/css";

import {Loader} from "@pg-design/loader-module";
import {type IModalOverlayVariant, Modal} from "@pg-design/modal-module";

interface IProps {
    isOpen: boolean;
    overlayVariant?: IModalOverlayVariant;
}

export const HomeMatchBasicPreferencesFlowLoadingModal = (props: IProps) => {
    return (
        <Modal isOpen={props.isOpen} className={modalStyle} showCloseButton={false} overlayVariant={props.overlayVariant}>
            <Modal.Content className={loaderWrapperStyle}>
                <Loader size="lg" />
            </Modal.Content>
        </Modal>
    );
};

const modalStyle = css({
    sm: {
        width: "544px",
        borderRadius: 2
    }
});

const loaderWrapperStyle = css({
    minHeight: "420px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
import {css} from "@panda/css";

import {Loader} from "@pg-design/loader-module";
import {type IModalOverlayVariant, Modal} from "@pg-design/modal-module";

interface IProps {
    isOpen: boolean;
    overlayVariant?: IModalOverlayVariant;
}

export const HomeMatchBasicPreferencesFlowLoadingModal = (props: IProps) => {
    return (
        <Modal isOpen={props.isOpen} className={modalStyle} showCloseButton={false} overlayVariant={props.overlayVariant}>
            <Modal.Content className={loaderWrapperStyle}>
                <Loader size="lg" />
            </Modal.Content>
        </Modal>
    );
};

const modalStyle = css({
    sm: {
        width: "544px",
        borderRadius: 2
    }
});

const loaderWrapperStyle = css({
    minHeight: "420px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
